import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ chapter, overline, title }) => (
  <div className="relative mb-14 sm:mb-16 md:mb-24">
    <span className="chapter-num absolute -top-10 sm:-top-16 -left-1 sm:-left-2 text-[5rem] sm:text-[7rem] md:text-[12rem] font-bold">
      {chapter}
    </span>
    <div className="relative">
      <Reveal>
        <p className="overline mb-4">{overline}</p>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl leading-[1.05]">
          {title}
        </h2>
      </Reveal>
    </div>
  </div>
);
